import React from 'react'

import {
	Container,
	ConfirmButton,
	CancelButton,
} from './ConfirmCancelButtons.styles'

interface ConfirmCancelButtonsProps {
	confirmText: string,
	onConfirm: () => any,
	cancelText: string,
	onCancel: () => any,

	confirmDisabled?: boolean,
}

export default function ConfirmCancelButtons(
	{
		confirmText,
		onConfirm,
		cancelText,
		onCancel,
		confirmDisabled,
		...props
	}: ConfirmCancelButtonsProps,
) {
	return (
		<Container {...props}>
			<ConfirmButton
				className={confirmDisabled ? 'disabled' : ''}
				onClick={onConfirm}
			>
				{confirmText}
			</ConfirmButton>
			<CancelButton
				onClick={onCancel}
			>
				{cancelText}
			</CancelButton>
		</Container>
	)
}
